var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6448 5.6767C18.0854 5.23622 18.3329 4.63876 18.333 4.01574C18.3331 3.39273 18.0857 2.79521 17.6452 2.35462C17.2047 1.91403 16.6073 1.66646 15.9842 1.66638C15.3612 1.6663 14.7637 1.91372 14.3231 2.3542L3.20145 13.4784C3.00797 13.6713 2.86488 13.9088 2.78478 14.17L1.68395 17.7967C1.66241 17.8688 1.66079 17.9453 1.67924 18.0182C1.6977 18.0912 1.73555 18.1577 1.78878 18.2109C1.84201 18.264 1.90863 18.3018 1.98158 18.3201C2.05453 18.3384 2.13108 18.3367 2.20312 18.315L5.83062 17.215C6.09159 17.1357 6.32909 16.9934 6.52228 16.8009L17.6448 5.6767Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNew);
export default __webpack_public_path__ + "static/media/EditNew.59b7f2e2cbe45b543eabc5daad622b50.svg";
export { ForwardRef as ReactComponent };